const roomsDetails = {
    blue: {
        name: 'Синяя',
        capacity: 50,
        location: '2 этаж'
    },
    yellow: {
        name: 'Желтая',
        capacity: 40,
        location: '5 этаж'
    },
    red: {
        name: 'Красная',
        capacity: 60,
        location: '3 этаж'
    },
    large: {
        name: 'Просторная',
        capacity: 130,
        location: 'мансарда'
    }
}

export default roomsDetails



// WEBPACK FOOTER //
// ./src/edit-lib/roomsDetails.js